import { createContext } from 'react';

import type { AddendumContextState } from './addendum.model';

export const AddendumContext = createContext<AddendumContextState | undefined>(undefined);

AddendumContext.displayName = 'AddendumContext';
